// src/constants/apiConfig.js
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'https://backend.kelvinkwesidanquah.com/api/v1',
    // BASE_URL: process.env.REACT_APP_API_URL || 'REACT_APP_API_URL=http://127.0.0.1:8000/api/v1',
  TIMEOUT: 30000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
};